import React, { useContext, useEffect, useRef, useState } from "react";

import {
  SimpleGrid,
  Select,
  Button,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  useToast,
  Wrap,
  WrapItem
} from "@chakra-ui/react";
import AstroCard from "./AstroCard";
import { BsSearch } from "react-icons/bs";
import { IconButton, VStack, Box } from "@chakra-ui/react";
import axios from "axios";
import AdminLogin from "../../AdminNav/Login";
import { MyContext } from "../../../MyProvider";

import { FilterTabs, Ledger, PageHeader, Pagination, SearchField, matchesSearch } from "../../../components/ui";
import { API_URL } from "../../../Apis/config";

function Astro() {
  
  const {horoData,horoApi,userApi} =useContext(MyContext);//main data from context
  const [filter,setFilter]=useState("Pending");//colored filters on top of ui
  const [counts, setCounts] = useState({
    total: 0,
    completed: 0,
    pending: 0,
    paid: 0,
    unpaid: 0,
    latest:0,
  });//count of colored filters on top of ui
  
  const [astrology, setAstrology] = useState([]);//display data in ui
  const [search, setSearch] = useState("");//search bar of ui
  const [currentPage, setCurrentPage] = useState(1);//display page of ui
  const [astrologyPerPage] = useState(8);//count per page cards
  const searchOption=useRef('name');//search filter
  const toast = useToast();
  
  useEffect(() => {
    
    const updatedCounts = {
      total: horoData.length,
      completed: horoData.filter((ele) => ele.horoStatus === "Completed").length,
      pending: horoData.filter((ele) => ele.horoStatus === "Pending").length,
      paid: horoData.filter((ele) => ele.paymentStatus === true).length,
      unpaid: horoData.filter((ele) => ele.paymentStatus === false).length,
      latest:horoData.filter((ele) => ele.horoDate == today).length
    };
    setCounts(updatedCounts);


    
  }, [horoData]);

  useEffect(()=>{

    switch (filter) {
      case "Completed":
        setAstrology(horoData.filter((ele) => ele.horoStatus === "Completed"));
        break;
      case "Pending":
        setAstrology(horoData.filter((ele) => ele.horoStatus === "Pending"));
        break;
      case "Paid":
        setAstrology(horoData.filter((ele) => ele.paymentStatus === true));
        break;
      case "Unpaid":
        setAstrology(horoData.filter((ele) => ele.paymentStatus === false));
        break;
      case "Latest":setAstrology(horoData.filter((ele) => ele.horoDate === today));
      break;  
      default:
        setAstrology([...horoData]);
        break;
    }
    

  },[filter,horoData]);


  useEffect(()=>{
    if(currentPage!=1){setCurrentPage(1)};
  },[filter]);
  
useEffect(()=>{
  
if(filter!="Astro"){setFilter("Astro")};
if(currentPage!=1){setCurrentPage(1)};
if(search==""){setAstrology([...horoData])}
else if(search.length>2){setAstrology(horoData.filter((el)=>matchesSearch(el,searchOption.current,search)))}
},[search]);

  
  
  const today=new Date().toLocaleDateString("en-GB");

  // Get current appointments based on pagination
  const indexOfLastAppointment = currentPage * astrologyPerPage;
  const indexOfFirstAppointment = indexOfLastAppointment - astrologyPerPage;
  const currentAppointments = astrology.slice(
    indexOfFirstAppointment,
    indexOfLastAppointment
  );//can be set in useffect for change in astrology and currentpage

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const goToNextPage = () => {
    if (currentPage < Math.ceil(astrology.length / astrologyPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  const getHeaderStyle = (name) => ({
    cursor: "pointer",
    backgroundColor: filter === name ? "yellow" : "transparent",
    color: filter === name ? "black" : "white"
    
  });

  const updateHoro=async()=>{

    await horoApi();
    await userApi();
  };

  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  const handleSubmit = (formData, id) => {
    // console.log(formData);
    // Here, you can use the formData object as the payload
    // to send it to your backend or perform any necessary actions
    axios
      .patch(`${API_URL}/horo/${id}`, formData)
      .then((res) => {
        updateHoro();
        toast({
          title: "Astro updated",
          description: "Astro has been updated successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        
        //add horo update function
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:"Error occured while updating astro",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };
  const onDeleteConfirm = (id) => {
    // setIsDeleteAlertOpen(false);
    // Perform delete logic here
    axios
      .delete(`${API_URL}/horo/${id}`)
      .then((res) => {
        updateHoro();
        //add horo delete function
        toast({
          title: "Astro deleted",
          description: "Astro has been deleted successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:
            "Error occured while deleting astro",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };
  return (
    <>
      <PageHeader title="Astro" subtitle="Horoscope requests">
        <SearchField
          options={[{ value: "name", label: "Name" }, { value: "phone", label: "Mobile" }, { value: "horoDate", label: "Submission" }]}
          onFieldChange={(event)=>{searchOption.current=event.target.value;}}
          onSearch={(e) => setSearch(e.target.value)}
        />
      </PageHeader>
      <FilterTabs
        active={filter}
        onChange={handleFilterChange}
        tabs={[
          { key: "Pending", label: "Pending", count: counts.pending },
          { key: "Completed", label: "Completed", count: counts.completed },
          { key: "Paid", label: "Paid", count: counts.paid },
          { key: "Unpaid", label: "Unpaid", count: counts.unpaid },
          { key: "Latest", label: "Booked today", count: counts.latest },
          { key: "Astro", label: "All", count: counts.total },
        ]}
      />
      <Ledger
        columns="minmax(0,1.6fr) minmax(0,1fr) minmax(0,1fr) 110px 300px"
        heads={["Name", "Date of birth", "Submitted", "Status", ""]}
        isEmpty={astrology.length === 0}
        emptyText="No astro requests here. Try another filter or clear the search."
      >
        {currentAppointments.map((apt) => (
          <AstroCard
            key={apt._id}
            User={apt}
            Update={handleSubmit}
            Delete={onDeleteConfirm}
          />
        ))}
      </Ledger>
      <Pagination
        currentPage={currentPage}
        pageCount={Math.ceil(astrology.length / astrologyPerPage)}
        onPrevious={goToPreviousPage}
        onNext={goToNextPage}
        onPage={paginate}
      />
    </>
  );
}

export default Astro;
